import React from 'react';
import { Text } from '@carnica/ui-kit';
import { withRenderFlag } from '@beef/react';

import { AccumCommonPropsType } from 'types/accumulators';

export const _AdditionalAccExpirationText: React.FC<AccumCommonPropsType> = ({
  additionalBillingInfo,
  className,
  isMobile,
}) => {
  return (
    <Text className={className} color="tertiary-invert" size={isMobile ? '2xs' : 'xs'}>
      {additionalBillingInfo}
    </Text>
  );
};

export const AdditionalAccExpirationText: React.FC<
  { shouldRender: boolean } & AccumCommonPropsType
> = withRenderFlag(_AdditionalAccExpirationText);
